export default class CheckVersion {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.gateways.serverInfo.fetch();
  }

  static get jobId() {
    return 'checkVersion';
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/version/check_version.js